import axios from "axios";

export interface LocationData {
  city: string;
  state: string;
  country: string;
  countryCode: string;
  source: "geolocation" | "ip";
}

let globalLocation: LocationData | null = null;

export const getLocation = async (): Promise<LocationData | null> => {
  if (globalLocation) return globalLocation;

  const getIpLocation = async (): Promise<LocationData | null> => {
    try {
      const res = await axios.get("https://ipwho.is/");
      return {
        city: res.data.city || "",
        state: res.data.region || "",
        country: res.data.country || "",
        countryCode: res.data.country_code || "",
        source: "ip",
      };
    } catch {
      return null;
    }
  };

  if (typeof navigator !== "undefined" && navigator.geolocation) {
    try {
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          const timeout = setTimeout(() => {
            reject(new Error("Geolocation timeout"));
          }, 5000);

          navigator.geolocation.getCurrentPosition(
            (pos) => {
              clearTimeout(timeout);
              resolve(pos);
            },
            (err) => {
              clearTimeout(timeout);
              reject(err); // pass GeolocationPositionError
            },
            { enableHighAccuracy: false, timeout: 5000, maximumAge: 0 }
          );
        }
      );

      const res = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${position.coords.latitude}&lon=${position.coords.longitude}`
      );

      const { address } = res.data;
      globalLocation = {
        city:
          address.city ||
          address.town ||
          address.village ||
          address.state_district ||
          "",
        state: address.state || "",
        country: address.country || "",
        countryCode: address.country_code?.toUpperCase() || "",
        source: "geolocation",
      };

      return globalLocation;
    } catch (err: any) {
      // If user denied geolocation permission, fallback to IP
      if (err.code === 1 /* PERMISSION_DENIED */) {
        globalLocation = await getIpLocation();
        return globalLocation;
      }
    }
  }

  // If geolocation is not supported or fails unexpectedly, use IP
  globalLocation = await getIpLocation();
  return globalLocation;
};

export const getGlobalLocation = (): LocationData | null => {
  return globalLocation;
};
